/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DatatableColumnConfiguration {
    getFixupPrototypeFunction() { return DatatableColumnConfiguration.fixupPrototype; }

    static newInstance(model: Partial<DatatableColumnConfiguration>): DatatableColumnConfiguration {
        let obj = Object.assign(new DatatableColumnConfiguration(), model);
        DatatableColumnConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DatatableColumnConfiguration>): DatatableColumnConfiguration {
        if (!model) return null;
        return DatatableColumnConfiguration.newInstance(<DatatableColumnConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DatatableColumnConfiguration) {
        if (!obj) return;

        models.DatatableColumnConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DatatableColumnConfiguration): boolean {
        Object.setPrototypeOf(obj, DatatableColumnConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    id: string;

    name: string;

    enabled: boolean;

}
